import { render, staticRenderFns } from "./AssessmentWrapper.vue?vue&type=template&id=7e602f61"
import script from "./AssessmentWrapper.vue?vue&type=script&lang=js"
export * from "./AssessmentWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports